exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1V2NX{display:grid;grid-template-columns:repeat(12, minmax(0, 1fr))}@media all and (-ms-high-contrast: none){._1V2NX{display:-ms-flexbox;-ms-flex-wrap:wrap;-ms-flex-dirextion:row-reverse}}\n", ""]);

// Exports
exports.locals = {
	"root": "_1V2NX"
};